import { useEffect, useState } from 'react';

import Card from '../../../components/cards/Card';
import SInput from '../../../components/form/SInput';
import { Pallet } from '../../../data';
import { toast } from 'react-toastify';
import PDFDialog from '../../../components/modals/PDFDialog';
import { defaultFrom } from '../../../options';
import usePdfDialogHook from '../../../../redux/hooks/usePdfDialogHook';
import PrintCardsContainer from '../../../components/cards/PrintCardsContainer';
import PageHeader from '../../../components/page/PageHeader';
import useUrlParams from '../../../hooks/useUrlParams';
import { isNullOrWhitespace } from '../../../helpers/string-helper';

// http://localhost:3000/outbound-pallets-generator?shipmentID=12345&shipmentName=TestShipment&defaultFrom=NYC&&destinationFC=ATL3&destinationAddress=FBA SJK Enterprises LLC\nATL3\n445 Valentine Industrial\nParkway Pendergrass GA 30567\nUnited States&destinationAddressBasic=123+Main+St&packingListNumber=PL98765&amazonReferenceID=AR56789&shipmentProNumber=SP123456&shipmentPalletNumber=PN789
// http://localhost:3000/pro-pallets-generator?shipmentID=12345&shipmentName=TestShipment&defaultFrom=NYC&&destinationFC=ATL3&destinationAddress=FBA SJK Enterprises LLC\nATL3\n445 Valentine Industrial\nParkway Pendergrass GA 30567\nUnited States&destinationAddressBasic=123+Main+St&packingListNumber=PL98765&amazonReferenceID=AR56789&shipmentProNumber=SP123456&shipmentPalletNumber=PN789

type OutboundAndPalletProPageProps = {
  apiUrl: string;
  headingText: string;
  allowToAddPallet: boolean;
};

function OutboundAndPalletProPage({
  apiUrl,
  headingText,
  allowToAddPallet
}: OutboundAndPalletProPageProps) {
  const { canGenerate, isPDFDialogOpen, setIsPDFDialogOpen, pdfBase64, print } = usePdfDialogHook();

  const {
    resetAll,

    shipmentID,
    setShipmentID,
    shipmentName,
    setShipmentName,
    packingListNumber,
    destinationFC,
    destinationAddress,
    setDestinationAddress,
    destinationAddressBasic,
    amazonReferenceID,
    setAmazonReferenceID,
    shipmentProNumber,
    shipmentPalletNumber
  } = useUrlParams();

  const [pallets, setPallets] = useState<Pallet[]>([]);

  // Add init pallet
  useEffect(() => {
    addPallet();
  }, []);

  const addPallet = () => {
    setPallets([...pallets, { weight: '', height: '', numberOfBoxes: '' }]);
  };

  const printPalletLabel = async () => {
    if (
      !isNullOrWhitespace(shipmentID) &&
      !isNullOrWhitespace(shipmentName) &&
      !isNullOrWhitespace(destinationAddress)
    ) {
      await print({
        apiUrl,
        data: {
          shipmentID,
          shipmentName,
          from: defaultFrom,
          to: destinationAddress,
          destinationFc: destinationFC,
          destinationFcBasic: destinationAddressBasic,
          shipmentCode: shipmentID,
          packingListNumber,
          amazonRefID: amazonReferenceID,
          pallets,
          proNumber: shipmentProNumber,
          palletCount: shipmentPalletNumber
        }
      });
    } else toast.warn('Missing inputs');
  };
  const clearAll = () => {
    resetAll();
    setPallets([{ weight: '', height: '', numberOfBoxes: '' }]);
  };

  return (
    <div className="flex flex-col w-full">
      <PageHeader headingText={headingText} />
      <PrintCardsContainer
        leftCard={
          <Card headerText="1. Shipment ID & Destination Info">
            <div className="flex flex-wrap">
              <div className="flex flex-col w-full gap-4 mt-3">
                <SInput name="Shipment ID" value={shipmentID} onChange={setShipmentID} />
                <SInput name="Shipment Name" value={shipmentName} onChange={setShipmentName} />
                <SInput
                  name="Amazon Reference ID"
                  value={amazonReferenceID}
                  onChange={setAmazonReferenceID}
                />
                <SInput
                  name="Destination Address"
                  value={destinationAddress}
                  onChange={setDestinationAddress}
                />
              </div>
            </div>
          </Card>
        }
        rightCard={
          <Card headerText="Print">
            <div className="flex flex-wrap gap-5">
              <button
                className="w-full base-gray-button"
                hidden={!allowToAddPallet}
                disabled={!canGenerate}
                onClick={addPallet}
              >
                Add Pallet
              </button>
              <button
                disabled={!canGenerate}
                onClick={() => {
                  printPalletLabel();
                }}
                className="w-full base-green-button"
              >
                Close Box and Print
              </button>
              <button disabled={!canGenerate} onClick={clearAll} className="w-full base-red-button">
                Clear All
              </button>
            </div>
          </Card>
        }
      />

      <PDFDialog isOpen={isPDFDialogOpen} setIsOpen={setIsPDFDialogOpen} pdf={pdfBase64} />

      <div hidden={!allowToAddPallet}>
        <Card headerText="2. Pallets">
          {pallets.map((x, i) => (
            <div key={`pallet_${i}`} className="grid grid-cols-3 gap-5 mt-5">
              <SInput
                name="Height"
                value={x.height}
                onChange={(val: any) => {
                  pallets[i].height = val;
                  setPallets([...pallets]);
                }}
              />
              <SInput
                name="Weight"
                value={x.weight}
                onChange={(val: any) => {
                  pallets[i].weight = val;
                  setPallets([...pallets]);
                }}
              />
              <SInput
                name="Number of Boxes"
                value={x.numberOfBoxes}
                onChange={(val: any) => {
                  pallets[i].numberOfBoxes = val;
                  setPallets([...pallets]);
                }}
              />
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}

export default OutboundAndPalletProPage;
